<ng-container *transloco="let t; prefix: 'nav'">
  <div
    class="mt-5 fixed bottom-0 right-0 left-0 md:mt-10 md:max-w-[750px] mx-auto w-full z-50 md:hidden"
  >
    <div
      class="bg-white shadow-2xl shadow-black dark:shadow-2xl dark:shadow-stone-500 dark:bg-base-100 border-2 border-base-100 card marker:flex flex-row px-2 pt-2 pb-5 items-end rounded-b-none rounded-t-3xl w-full"
    >
      <div class="item flex flex-1 justify-center">
        <button
          routerLink="/home"
          class="p-0 flex flex-col gap-y-2 items-center rounded-box"
        >
          <i
            routerLinkActive="bg-primary !text-white"
            [routerLinkActiveOptions]="{ exact: true }"
            class="px-5 py-1 rounded-box text-primary dark:text-white fa-solid fa-house text-xl"
          ></i>
          <span class="m-0 text-xs">{{ t("home") }}</span>
        </button>
      </div>
      <div class="item flex flex-1 justify-center">
        <button
          routerLink="payments"
          class="p-0 flex flex-col gap-y-2 items-center rounded-box"
        >
          <i
            routerLinkActive="bg-primary !text-white"
            class="px-5 py-1 rounded-box text-primary dark:text-white fa-solid fa-exchange text-xl"
          ></i>
          <span class="m-0 text-xs">{{ t("payments") }}</span>
        </button>
      </div>
      @if (deviceService.isAndroid() || deviceService.isWeb()) {
        <div class="item hidden flex-1 justify-center">
          <button
            routerLink="insights"
            class="p-0 flex flex-col gap-y-2 items-center rounded-box"
          >
            <i
              routerLinkActive="bg-primary !text-white"
              class="px-5 py-1 rounded-box text-primary dark:text-white fa-solid fa-chart-mixed text-xl"
            ></i>
            <span class="m-0 text-xs">{{ t("insights") }}</span>
          </button>
        </div>
        <div class="item hidden flex-1 justify-center">
          <button
            routerLink="reports"
            class="p-0 flex flex-col gap-y-2 items-center rounded-box"
          >
            <i
              routerLinkActive="bg-primary !text-white"
              class="px-5 py-1 rounded-box text-primary dark:text-white fa-solid fa-file-chart-column text-xl"
            ></i>
            <span class="m-0 text-xs">{{ t("reports") }}</span>
          </button>
        </div>
      }
      <div class="item flex flex-1 justify-center">
        <button
          routerLink="services"
          class="p-0 flex flex-col gap-y-2 items-center rounded-box"
        >
          <i
            routerLinkActive="bg-primary !text-white"
            class="px-5 py-1 rounded-box text-primary dark:text-white fa-solid fa-grid-2 text-xl"
          ></i>
          <span class="m-0 text-xs">{{ t("services") }}</span>
        </button>
      </div>
      <div class="item flex flex-1 justify-center">
        <button
          routerLink="business"
          class="p-0 flex flex-col gap-y-2 items-center rounded-box"
        >
          <i
            routerLinkActive="bg-primary !text-white"
            class="px-5 py-1 rounded-box text-primary dark:text-white fa-solid fa-shop text-xl"
          ></i>
          <span class="m-0 text-xs">{{ t("my_business") }}</span>
        </button>
      </div>
    </div>
  </div>
</ng-container>

<!-- <div
  class="mt-5 mb-20 fixed bottom-0 right-0 left-0 md:mt-10 md:max-w-[750px] mx-auto w-full z-50 md:hidden"
>
  <div
    class="bg-white dark:bg-base-100 shadow-2xl border-2 border-base-100 card drop-shadow-2xl flex flex-row p-2 items-end rounded-b-none rounded-t-3xl w-full"
  >
    <div class="item flex flex-1 justify-center">
      <button
        class="p-0 flex flex-col gap-y-2 items-center hover:bg-gray-300 dark:hover:bg-gray-700 rounded-box"
      >
        <i class="fa-solid fa-house text-lg"></i>
        <span class="m-0 font-normal text-xs">Home</span>
      </button>
    </div>
    <div class="item flex flex-1 justify-center">
      <button
        class="p-0 flex flex-col gap-y-2 items-center hover:bg-gray-300 dark:hover:bg-gray-700 rounded-box"
      >
        <i class="fa-solid fa-exchange text-xl"></i>
        <span class="m-0 font-normal text-xs">Payments</span>
      </button>
    </div>
    <div class="item flex flex-1 justify-center">
      <button
        class="p-0 flex flex-col gap-y-2 items-center hover:bg-gray-300 dark:hover:bg-gray-700 rounded-box"
      >
        <i class="fa-solid fa-cog text-xl"></i>
        <span class="m-0 font-normal text-xs">Settings</span>
      </button>
    </div>
    <div class="item flex flex-1 justify-center relative">
      <button
        class="p-2 absolute bottom-0 bg-primary text-white drop-shadow-2xl size-[5rem] flex flex-col justify-center gap-y-2 mb-7 items-center hover:bg-gray-300 dark:hover:bg-gray-700 rounded-full"
      >
        <i class="fa-solid fa-camera-viewfinder text-4xl"></i>
      </button>
    </div>
  </div>
</div> -->
